import { useState } from 'react'
import { NodeViewWrapper, NodeViewContent } from '@tiptap/react'
import type { NodeViewProps } from '@tiptap/react'
import { MermaidDiagram } from '@/components/MermaidDiagram'
import { cn } from '@/lib/utils'
import { Code, Eye } from 'lucide-react'

export function MermaidNodeView({ node }: NodeViewProps) {
  const [showPreview, setShowPreview] = useState(false)
  const content = node.textContent

  return (
    <NodeViewWrapper className="my-4 rounded-lg border border-border overflow-hidden">
      <div className="flex items-center justify-between px-3 py-1.5 bg-muted/50 border-b border-border">
        <span className="text-xs font-medium text-muted-foreground">
          Mermaid Diagram
        </span>
        <div className="flex gap-1">
          <button
            type="button"
            onClick={() => setShowPreview(false)}
            className={cn(
              'p-1 rounded text-xs',
              !showPreview
                ? 'bg-accent text-accent-foreground'
                : 'text-muted-foreground hover:bg-accent/50'
            )}
            title="Edit code"
            aria-label="Edit code"
          >
            <Code className="h-3.5 w-3.5" />
          </button>
          <button
            type="button"
            onClick={() => setShowPreview(true)}
            className={cn(
              'p-1 rounded text-xs',
              showPreview
                ? 'bg-accent text-accent-foreground'
                : 'text-muted-foreground hover:bg-accent/50'
            )}
            title="Preview diagram"
            aria-label="Preview diagram"
          >
            <Eye className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>

      {showPreview ? (
        <div className="p-4 bg-background min-h-[100px] flex items-center justify-center">
          <MermaidDiagram chart={content} className="my-0" />
        </div>
      ) : (
        <div className="bg-muted">
          <NodeViewContent
            className="p-4 text-sm font-mono text-foreground outline-none whitespace-pre"
          />
        </div>
      )}
    </NodeViewWrapper>
  )
}
